
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import IconReport from "@/components/common/icon/IconReports.vue";
import POptionBar from "@/components/look/POptionBar.vue";

@Component({
  name: "reports-header",
  components: {
    POptionBar,
    IconReport,
  },
})
export default class ReportsHeader extends Vue {
  @Prop({ required: true, default: "reports" }) value!: string;
  @Prop({ required: true }) enableImports!: boolean;

  options: { text: string; pressed: boolean; data: string }[] = [];
  action = {
    reports: "reports",
    imports: "imports",
  };
  actionSelected: string | null = null;

  @Watch("value", { immediate: true })
  onValueChanged(action: string): void {
    this.actionSelected = action;
    this.options.forEach((opt) => (opt.pressed = opt.data === action));
  }

  mounted(): void {
    this.options = [
      {
        text: this.$t("sidebar.exports") as string,
        pressed: false,
        data: this.action.reports,
      },
      {
        text: this.$t("sidebar.imports") as string,
        pressed: false,
        data: this.action.imports,
      },
    ];
    this.onValueChanged(this.value);
  }

  redirect(action: string): void {
    this.actionSelected = action;
    this.$emit("input", action);
  }
}
